import "./FourthItemCards.css"

export default function FourthItemCards() {
    return (
        <div className="FourthItemCards container">
            <div className="FourthItemCards-Item">
                <div className="FourthItemCards-Item1Left">
                    <img src="http://connection.media.clients.ellingtoncms.com/img/photos/2013/07/23/R0724-208_t670.jpg?b3f6a5d7692ccc373d56e40cf708e3fa67d9af9d" alt="" />
                </div>
                <div className="FourthItemCards-Item1Right">
                    <h4>Charity Events!<button className="btn btn-warning">Volunteer</button></h4>
                    <p>Join us for our quarterly dog wash! Owners bring their pets (with leashes!) 
                        and the pets get the bath of their LIVES [snacks included!] <br/><br/>
                        Dates: <br/>
                        <span className="btn btn-outline-primary">1/25</span>
                        <span className="btn btn-outline-primary">4/25</span>
                        <span className="btn btn-outline-primary">7/25</span>
                        <span className="btn btn-outline-primary">10/31</span>
                        </p>
                </div>
            </div>

            <div className="FourthItemCards-Item">
                <div className="FourthItemCards-Item1Left">
                    <img src="https://www.pricechopper.com/wp-content/uploads/2020/09/Pet-Food-Drive_FB_1200x628-768x402.jpg" alt="" />
                </div>
                <div className="FourthItemCards-Item1Right">
                    <h4>Food Drive! <button className="btn btn-warning">Volunteer</button></h4>
                    <p>Donate dry/wet food, litter, pee pads, or anything you can think of, we would appreciate it !<br/><br/>
                        Join us for our monthly food drives!<br/>
                        <span className="btn btn-outline-primary">1/30</span>
                        <span className="btn btn-outline-primary">2/27</span>
                        <span className="btn btn-outline-primary">3/30</span>
                        <span className="btn btn-outline-primary">4/30</span>
                        <span className="btn btn-outline-primary">5/30</span>
                        <span className="btn btn-outline-primary">6/30</span>
                        <span className="btn btn-outline-primary">7/30</span>
                        <span className="btn btn-outline-primary">8/30</span>
                        <span className="btn btn-outline-primary">9/30</span>
                        <span className="btn btn-outline-primary">10/30</span>
                        <span className="btn btn-outline-primary">11/30</span>
                        <span className="btn btn-outline-primary">12/13</span>
                    </p>
                </div>
            </div>

            <div className="FourthItemCards-Item">
                <div className="FourthItemCards-Item1Left">
                    <img src="http://images.ctfassets.net/oartd9t7ehdh/1MTf8u4BXiuwEEg2gsC2eo/baa6ad30bf517cce1436eb0149e4d997/620x346-Do-Dogs-Like-To-Be-Cuddled.jpg" alt="" />
                </div>
                <div className="FourthItemCards-Item1Right">
                    <h4>CUDDLE PARTY! <button className="btn btn-warning">Volunteer</button></h4>
                    <p> Our famous meet & greet at the dog park! Meet the pets that are ready to be 
                        adopted and see if they jibe with you ! Who doesn't love a cuddle party?!?!?<br/><br/>
                        Dates: <br/>
                        <span className="btn btn-outline-primary">2/25</span>
                        <span className="btn btn-outline-primary">5/25</span>
                        <span className="btn btn-outline-primary">8/25</span>
                        <span className="btn btn-outline-primary">11/30</span>
                        </p>
                </div>
            </div>
        </div>
    )
}
